/*LIBRARY*/
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

const COLLAB_BLOCK_VIEWER = ({ auth }) => {
  return (
    <main
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh", // Full viewport height
        width: "100%",
        backgroundColor: "#f8f9fa", // Light clean background
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <section
        style={{
          backgroundColor: "#ffffff",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "500px",
          width: "100%",
        }}
      >
        <h1
          style={{
            fontSize: "22px",
            fontWeight: "700",
            color: "#2d3748",
            margin: "0 0 12px 0",
          }}
        >
          Akses Terbatas
        </h1>

        <p
          style={{
            fontSize: "15px",
            color: "#718096",
            lineHeight: "1.6",
            margin: "0 0 24px 0", // Added bottom margin to separate from the link
          }}
        >
          Ini data privat. Silakan masuk atau daftar untuk mengaksesnya.
        </p>

        <Link
          to="/dashboard"
          style={{
            color: "#3182ce",
            textDecoration: "none",
            fontWeight: "600",
            fontSize: "14px",
          }}
        >
          Kembali ke Beranda
        </Link>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(COLLAB_BLOCK_VIEWER);
